var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.sale_status.models.length)?_c('b-input-group',{staticClass:"w-300 m-b-10",attrs:{"prepend":"Estado"}},[_c('b-form-select',{attrs:{"options":_vm.get_options_simple('sale_status')},model:{value:(_vm.sale_status_id),callback:function ($$v) {_vm.sale_status_id=$$v},expression:"sale_status_id"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }